import React, { useState } from "react";
import { Box, Card, CardMedia, Typography, Dialog } from "@mui/material";
import VideoPlayer from "../ui/play/VideoPlayer";

const Card17VideoHome = ({ card }) => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleVideoClick = (videoData) => {
    setSelectedVideo(videoData); // Set the selected video data
  };

  const fixUrlProtocol = (url) => {
    if (!url) return '';
    return url.startsWith('http:') ? url.replace(/^http:/, 'https:') : url;
  };
  const handleClosePlayer = () => {
    setSelectedVideo(null); // Close the video player
  };

  return (
    <>
      <Box sx={{ marginBottom: 4 }}>
        {card.cardMetaData?.title && (
          <Typography variant="h6" sx={{ marginBottom: 2, color: "#771615" }}>
            {card.cardMetaData.title}
          </Typography>
        )}
        <Box sx={{ display: "flex", gap: 2, overflowX: "auto", padding: "8px" }}>
          {card.cardData.map((item, idx) => (
            <Card
              key={idx}
              onClick={() => handleVideoClick(item.data)} // Trigger video click
              sx={{
                minWidth: 240,
                height: 250,
                borderRadius: 2,
                overflow: "hidden",
                boxShadow: "0 2px 4px #771615",
                position: "relative",
                cursor: "pointer",
                background: "linear-gradient(to top, #fff 0%, #FF9800 100%)",
              }}
            >
              <CardMedia
                component="img"
                height="140"
                image={item.data.thumbnail}
                alt={item.data.title}
                sx={{
                  objectFit: "cover",
                }}
              />
              <Box sx={{ padding: 2 }}>
                <Typography
                  variant="body1"
                  fontWeight="bold"
                  sx={{
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    color: "#771615",
                  }}
                >
                  {item.data.title}
                </Typography>
              </Box>

              {/* Bottom Left Section */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 10,
                  left: 10,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  backgroundColor: "#771615",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: 4,
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {item.data.streamerName}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  <span role="img" aria-label="like">
                    ❤️
                  </span>
                  <Typography variant="body2">
                    {item.data.like_count_display}
                  </Typography>
                </Box>
              </Box>
            </Card>
          ))}
        </Box>
      </Box>

      {/* Video Player Dialog */}
      {selectedVideo && (
        <Dialog
          open={Boolean(selectedVideo)}
          onClose={handleClosePlayer}
          fullScreen
          sx={{
            "& .MuiPaper-root": {
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.3)",
              borderRadius: "0px",
              backgroundColor: "#000",
            },
          }}
        >
        

<VideoPlayer
  videoSrc={fixUrlProtocol(selectedVideo?.downloadUrl)}
  onClose={handleClosePlayer}
  title={selectedVideo?.title}
/>
          
        </Dialog>
      )}
    </>
  );
};

export default Card17VideoHome;